<template>
  <mdb-container fluid class="gp-has-header text-left" v-if="meetings">
    <mdb-card v-if="joinMessage" class="mb-4">
      <mdb-card-header class="secondary-color">
        <h4>Joined Meeting</h4>
      </mdb-card-header>
      <mdb-card-body>
        <div v-html="joinMessage"></div>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="newMeetingDialog" class="mb-4">
      <mdb-card-header class="secondary-color">
        <h3>Create a Meeting</h3>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-input v-model="meetingName" label="Name of Meeting"/>

        <mdb-btn @click="createMeeting" :disabled="!meetingName">Create</mdb-btn>
        <mdb-btn @click="newMeetingDialog=false">Cancel</mdb-btn>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="userDetails.isTenantAdmin" class="mb-4">
      <mdb-card-header class="secondary-color">
        <h3>Meetings I Own</h3>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-btn @click="newMeetingDialog=true" v-if="!newMeetingDialog" icon="plus-circle">Create a Meeting</mdb-btn>
        <mdb-tbl>
          <mdb-tbl-body>
            <tr v-for="m in meetings.created" :key="m.id">
              <td><h4 class="text-info">{{ m.name }}</h4></td>
              <td>
                <mdb-btn @click="joinMeeting(m)" color="success" icon="handshake" size="sm" rounded>Join</mdb-btn>
                <mdb-btn @click="manageInternalGuests(m)" color="success" icon="users" size="sm" rounded>Manage Internal Guests</mdb-btn>
                <mdb-btn @click="manageExternalGuests(m)" color="warning" icon="users" size="sm" rounded>Manage External Guests</mdb-btn>
                <mdb-btn @click="deleteMeeting(m)" color="danger" icon="trash" size="sm" rounded>Delete</mdb-btn>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>

      </mdb-card-body>
    </mdb-card>

    <mdb-card class="mb-4">
      <mdb-card-header class="secondary-color">
        <h3>Meetings I'm Invited To</h3>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-btn @click="loadMeetings" icon="recycle">Refresh</mdb-btn>
        <div v-if="meetings.invited.length == 0 && !userDetails.isTenantAdmin">
          No meetings found. A meeting will show up here if a member of the {{ settings.siteName }} Admin team invited
          you.
        </div>
        <mdb-tbl>
          <mdb-tbl-body>
            <tr v-for="m in meetings.invited" :key="m.id">
              <td><h4 class="text-info">{{ m.name }}</h4></td>
              <td><mdb-btn @click="joinMeeting(m)" color="success" icon="handshake" size="sm" rounded>Join</mdb-btn></td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>

      </mdb-card-body>
    </mdb-card>

    <yes-no-modal v-if="deleteModal" @yes="doDeleteMeeting" @no="deleteModal=false"/>

    <mdb-modal :show="showGuestModal" class="text-center" size="lg" @close="showGuestModal=false">
      <mdb-modal-header :close="true" center class="primary-color">
        <h3 class="heading">Guests</h3>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div>
          <mdb-tbl striped responsive>
            <mdb-tbl-body>
              <tr v-for="g in guests" :key="g.id" class="text-left">
                <td style="width:75%">
                  <avatar :avatar="g.avatar" :size="50" containerClass=""/>
                  {{ g.name }}
                </td>
                <td style="width:25%">
                  <mdb-btn rounded tag="a" size="sm" color="danger" icon="trash" @click="deleteGuest(g)"/>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </div>

        <hr/>
        <mdb-input v-model="userSearch" label="Find User"
                   placeholder="Search"
                   id="existing-search"
                   type="text">
          <mdb-btn size="sm" slot="append" rounded icon="search" @click="doUserSearch">Search</mdb-btn>
        </mdb-input>
        <mdb-tbl striped responsive>
          <mdb-tbl-body>
            <tr v-for="f in foundUsers" :key="f.id" class="text-left">
              <td style="width:75%">
                <avatar :avatar="f.avatar" :size="50" containerClass=""/>
                {{ f.name }} - {{ f.email }}
              </td>
              <td style="width:25%">
                <mdb-btn size="sm" rounded icon="check" @click="addUser(f)">Add</mdb-btn>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>

        <mdb-btn @click="saveGuests" icon="save">Save</mdb-btn>
        <mdb-btn @click="showGuestModal=false" icon="minus-circle" color="warning">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="externalGuestManager" size="lg" @close="externalGuestManager = false">
      <mdb-modal-header :close="true" class="primary-color text-center">
        <h5>Manage External Guests</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <guest-manager :instant-meeting="currMeeting"/>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbView
} from 'mdbvue';
import YesNoModal from "./common/YesNoModal";
import Avatar from "./common/Avatar";
import GuestManager from "./common/GuestManager";

export default {
  name: 'Jiti-Meet',
  components: {
    mdbBtn,
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbView,
    mdbInput,
    mdbListGroup,
    mdbListGroupItem,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbTbl,
    mdbTblBody,
    YesNoModal,
    Avatar,
    GuestManager
  },
  data() {
    return {
      meetingName: "",
      newMeetingDialog: false,
      meetings: null,
      deleteCandidate: null,
      deleteModal: false,
      currMeeting: null,
      showGuestModal: false,
      guests: null,
      userSearch: "",
      foundUsers: null,
      externalGuestManager: false,
      joinMessage: ""
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
    userDetails() {
      return this.$store.state.userDetails
    }

  },
  mounted() {
    this.id = this.$route.params.id
    if (this.$route.query.event) this.id = this.$route.query.event
    this.loadMeetings()

  },
  methods: {
    doUserSearch() {
      let url = "/user/list?q=" + this.userSearch + "&max=10&offset=0"
      this.$store.dispatch("setExecuting", true)
      api.get(url).then(
        (results) => {
          this.foundUsers = results.data.rows
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteGuest(g) {
      console.log("Deleting ", g)
      let loc = -1
      for (let i = 0; i < this.guests.length; i++) {
        let guest = this.guests[i]
        console.log("Comparing to ", guest)
        if (guest.id == g.id) loc = i
      }
      if (loc >= 0) this.guests.splice(loc, 1)
    },
    addUser(u) {
      this.guests.unshift({id: u.id, name: u.name, userId: u.id, avatar: u.avatar})
      this.foundUsers = null
      this.userSearch = ""
    },
    saveGuests() {
      let payload = {users: []}
      for (let g of this.guests) {
        payload.users.push(g.userId)
      }
      this.$store.dispatch("setExecuting", true)
      api.post("/jitsi/guests/" + this.currMeeting.id, payload).then(
        (results) => {
          this.showGuestModal = false
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    manageExternalGuests(m) {
      this.currMeeting = m
      this.externalGuestManager = true
    },
    manageInternalGuests(m) {
      this.currMeeting = m
      this.$store.dispatch("setExecuting", true)
      api.get("/jitsi/guests/" + this.currMeeting.id).then(
        (results) => {
          this.guests = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })


      this.showGuestModal = true
    },


    deleteMeeting(m) {
      this.deleteCandidate = m
      this.deleteModal = true
    },
    doDeleteMeeting() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true);
      api.delete("/jitsi/delete/" + this.deleteCandidate.id).then(
        (results) => {
          let loc = this.meetings.created.indexOf(this.deleteCandidate)
          this.deleteCandidate = null
          this.meetings.created.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
          this.joinRequested = false
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    createMeeting: function () {
      this.$store.dispatch("setExecuting", true);
      api.post("/jitsi/create/", {name: this.meetingName}).then(
        (results) => {
          this.meetings.created.unshift(results.data)
          this.newMeetingDialog = false
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) {
            this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
            return
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})
          this.joinRequested = false
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    joinMeeting: function (m) {
      this.$store.dispatch("setExecuting", true);
      this.joinRequested = true
      api.get("/jitsi/instantJwt/" + m.id).then(
        (results) => {
          let url = results.data.url
          url += "?jwt=" + results.data.jwtToken
          window.open(url, "_blank")
          this.joinMessage = `<div class="text-info">Online event should have opened in a new window/tab. If it didn't,
          your browser may have treated it as a pop-up and blocked it. If that's the case, try <a href="${url}">this alternate link</a>. It is good for 1 hour. You can
          re-generate it by hitting the join button again.
          </div>`
          window.scrollTo(0,0)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    loadMeetings: function () {
      this.$store.dispatch("setExecuting", true);
      api.get("/jitsi/listMeetings").then(
        (results) => {
          this.meetings = results.data
          document.title = "Online Meetings"
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }
}
</script>
